import PropTypes from "prop-types";
import Client from "./Customer";
import { createField, getEntityTypes, getEntityDefaults } from "./utils";

const Parent = {
    id: createField(PropTypes.number, null),
    fileNo: createField(PropTypes.string, ""),
    client: createField(PropTypes.shape(getEntityTypes(Client)), getEntityDefaults(Client)),
};

export default Parent;
